import React from 'react';
import ReactDOM from 'react-dom';
import './style/core.scss';
import App from 'components/App/App';

ReactDOM.render(<App />, document.getElementById('root'));
